import MuiTab from "@material-ui/core/Tab";
import MuiTabs from "@material-ui/core/Tabs";
import { makeStyles } from "@material-ui/styles";
import { FieldConfig, useField, useFormikContext } from "formik";
import { t } from "i18next";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
type TabOption = { value: any; title: string };

interface Props extends FieldConfig {
  options: TabOption[];
  label?: string;
  value?: any;
  classOverride?: string;
  disabled?: boolean;
  handleFieldChange?: any;
}

const useTabsStyles = makeThemedStyles("Toolbars.Tabs", (theme) => ({
  root: {
    backgroundColor: "#fff",
    display: "inline-flex",
    alignItems: "center",
    border: "1.5px solid rgba(0,0,0,0.14)",
    borderRadius: "6px",
    minHeight: "32px",
    color: "rgb(148, 143, 143)",
    textTransform: "unset",
    width: "100%",
  },
  indicator: {
    borderRadius: "6px",
    height: "100%",
    backgroundColor: "rgb(244,244,244)",
  },
}));

const useTabStyles = makeThemedStyles("Toolbars.Tabs", (theme) => ({
  root: {
    flex: 1,
    minHeight: "30px",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    lineHeight: "28px",
    color: "#7E8791",
    maxWidth: "72vw",
  },
  selected: {
    zIndex: 1,
    color: "#fff",
    backgroundColor: "rgb(14, 37, 106)",
  },
}));

const useLabelStyles = makeStyles({
  label: {
    fontFamily: "Dubai",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#374151",
  },
});

const TabsBar = (props: Props) => {
  const tabClasses = useTabStyles();
  const tabsClasses = useTabsStyles();
  const labelClasses = useLabelStyles();
  const [field, meta] = useField(props);

  const { setFieldValue } = useFormikContext();
  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    if (!newValue || newValue === field.value) return;
    if (props.handleFieldChange) {
      props.handleFieldChange(newValue);
    } else {
      setFieldValue(props.name, newValue);
    }
  };
  return (
    <>
      {props.label && <p className={labelClasses.label}>{props.label}</p>}
      <MuiTabs
        classes={{
          root: `${tabsClasses.root} ${props.classOverride}`,
          indicator: tabsClasses.indicator,
        }}
        {...field}
        onChange={handleChange}
        value={props.value || false}
        style={{
          border:
            meta.touched && meta.error
              ? "1.5px solid red"
              : "1.5px solid rgba(0,0,0,0.14)",
        }}
      >
        {props.options.map((tab, index) => (
          <MuiTab
            key={index}
            classes={{ root: tabClasses.root, selected: tabClasses.selected }}
            value={tab.value}
            label={t(tab.title)}
            disabled={props.disabled !== undefined ? props.disabled : false}
          />
        ))}
      </MuiTabs>
      <span style={{ color: "red" }}>
        {meta.touched && !!meta.error && t(meta.error)}
      </span>
    </>
  );
};

export default TabsBar;
